const locale = require('raw-loader!../../LOCALE');
// const locale = "production";
let config = {};

try {
    config = Object.assign(require('./common.js'), require('./' + locale + '.js'));
}
catch (e) {
    console.error(e);
    throw 'Could not find configuration file ' + './' + locale + '.js';
}

export default config;


// WEBPACK FOOTER //
// ./src/config/config.js